export default __webpack_public_path__ + "static/media/kidsSmile.2b26ba50.jpg";